export default {
  FETCH_LIST: "FETCH_LIBRARY_LIST",
  FETCH_LIST_REQUEST: "FETCH_LIBRARY_LIST_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_LIBRARY_LIST_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_LIBRARY_LIST_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_LIBRARY_LIST",
  RESET_PAGES: "RESET_LIBRARY_PAGES",
}
